import React, { useEffect, useState } from 'react'
import { Space, Table, Flex } from 'antd';
import Main from '../../../cpn/Main';
import ExpenseTypeEdit from './ExpenseTypeEdit';    
import ExpenseTypeAdd from './ExpenseTypeAdd';
import { useFeiyongTypeListQuery } from '../../../store/DianShangYeWuApi';
import ExpenseTypeDel from './ExpenseTypeDel';  
function ExpenseTypeList() {
    const [list, setList] = useState();    
    const qy_id = JSON.parse(localStorage.getItem('jtg-caiwu_qy_id'))
    const qy_name = JSON.parse(localStorage.getItem('jtg-caiwu_qy_name'))   
    const yh_id = JSON.parse(localStorage.getItem('jtg-caiwu_yh_id'))
    const yh_name = JSON.parse(localStorage.getItem('jtg-caiwu_yh_name'))
    const {data, isSuccess} = useFeiyongTypeListQuery({fyt_qy_id:qy_id,});
    useEffect(() => {
        if (isSuccess) {
            // console.log(data);
            if(data.Status==='success'){                
                const newArr = data.Result.map(item => {
                    const {fyt_id:key,fyt_name,fyt_uname,fyt_ctime} = item;                 
                    return item = {key,fyt_name,fyt_uname,fyt_ctime}
                }) 
                const sortArr = newArr.sort( (a, b) => {      
                    let aTimeString = a.yh_ctime;
                    let bTimeString = b.yh_ctime;
                    let aTime = new Date(aTimeString).getTime();
                    let bTime = new Date(bTimeString).getTime();
                    return bTime - aTime;     
                    },)
                setList(sortArr)
            }else{
                setList('')
            }
            
        }
    }, [data, isSuccess])
    const columns = [
        {
            key: 'fyt_name',
            title: '名称',            
            dataIndex: 'fyt_name',
        },              
        {
            key: 'fklx_ctime',
            title: '新增',            
            dataIndex: 'fklx_ctime',
            render:(text,record) => {
                return<>{text} {record.fklx_uname}</>
            }
        },   
        {
            key: 'action',
            title: '操作',
            render: (_, record) => {
                return <>
                    <Space align='center' size='middle'>
                        <ExpenseTypeEdit
                            fyt_id={record.key} 
                            fyt_name={record.fyt_name} 
                            qy_id={qy_id}
                            qy_name={qy_name}
                            yh_id={yh_id}
                            yh_name={yh_name}
                        />
                        <ExpenseTypeDel
                            fyt_id={record.key}
                        />
                    </Space>
                </>
            }
        },
    ]   
    return (
        <Main selectedKeys={['/ExpenseTypeList']}>                       
            <Flex>
                <ExpenseTypeAdd 
                    qy_id={qy_id}
                    qy_name={qy_name}
                    yh_id={yh_id}
                    yh_name={yh_name}
                />
            </Flex>
            <Table 
                columns={columns} 
                dataSource={list} 
                pagination={{
                    showSizeChanger:true,
                    defaultPageSize:'50',
                    showTotal:(total) => `共${total}条`,
                }} 
                className="custom-table"
                style={{marginTop:"10px"}}
                bordered
                size='small'
                rowKey="key"
            />
        </Main>
    )
}

export default ExpenseTypeList
